module.exports = __webpack_public_path__ + "static/img/putaway_module.8ab1594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/putaway_module.svg
// module id = vo3S
// module chunks = 1